import React from "react";
import "./portal.css";
import Sidebar from "../sidebar/Sidebar";
import Analytics from "../../pages/anaytics/Analytics";
import Message from "../../pages/messagenotification/Message";
import Management from "../../pages/management/Management";
import Settings from "../../pages/settings/Settings";
import Home from "../../pages/home/Home";
import Device from "../../pages/device/Device";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Trackingaction from "../../pages/trackingaction/Trackingaction";

export default function Portal(props) {
  return (
    <Router>
      <div className="sidebarandscreen">
        <Sidebar />
        <Switch>
          <Route exact path="/account/">
            <Home logedinuser={props.logedinuser} />
          </Route>
          <Route exact path="/account/analytics">
            <Analytics />
          </Route>
          <Route exact path="/account/settings">
            <Settings />
          </Route>
          <Route exact path="/account/message">
            <Message />
          </Route>

          <Route exact path="/account/device">
            <Device incomingdata={props.payload} />
          </Route>

          <Route exact path="/account/track">
            <Trackingaction
              incomingdata={props.payload}
              activeVehicle={props.activeVehicle}
              activeImei={props.activeImei}
            />
          </Route>
          <Route exact path="/account/management">
            <Management
              sendCommand={props.publish}
              status={props.payload.message}
              activeVehicle={props.activeVehicle}
            />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}
